import React, { Component } from 'react';
import {NavLink, Link} from "react-router-dom";
import logodashheader  from '../Assets/logo-dash-header.png';
import FeedBackImg from '../Assets/ratings-review.png';
import Footer from "../Components/footer";
import  Header  from "../Components/header";
import SideBar from "../Components/sidebar";
import Button from "../Components/button";
import DataTable from "../Components/datatablesubmission";
import { Table } from "../Components/table";
import MaterialDataTable from "../Components/materialtable";
import { DateTime, RedirectNotLogin, RedirectContractor, getSession, UpdateState, getState, handleSubmit, BreedForm, AlertMessage, AlertMessageOut, serializeArray } from "../Components/function";

class MySubmission extends Component{

  constructor(props){
    super(props);
    
    this.state = {
      userID : '',
      scriptID: '',
      file: '',
      message: '',
    }
    }
    
    componentDidMount(){
      RedirectNotLogin();
      RedirectContractor();
    }

    componentDidUpdate() {
      RedirectNotLogin();
      RedirectContractor();
    }
 
  render(){
    return (
        <div className="App AppWrap">
    
    <Header self={this}/>
    <SideBar self={this}/>

    <div className="App iBG dash-dash">
    <div className="containers">
   
    
  
  <div className="card-lt-wrap">
    <div className="card-lt">
     
     {AlertMessageOut(this)}

     <DataTable 
     route="fetch"
     badge={['', '', 'status_badge', '']}
     thclassX={['', 'absorbing-column', '', 'nowrap']}
     classX={['', 'absorbing-column min-width-td', '', 'nowrap chip-flex']}
     th={
        ['Script ID', 'Title', 'Status', 'Submitted Date']
     }
     td={
        ['scriptID', 'title', 'status', 'added']
    }
    append={['resubmit', '', '', '']}
     cmd="mysubmission"
     self={this}
     />

    
     </div>

        <Footer classX="dash-footer"/>

    </div>
    
    </div>

    </div>

    </div>
    );
}

}

export default MySubmission;